export default __webpack_public_path__ + "static/media/a011-fsi-06.e7967633.svg";